import { render } from "./IconEmpty.vue?vue&type=template&id=61eb37c6"
const script = {}
script.render = render

export default script